import {twMerge} from '@sdox/utils'

import type {ComponentProps} from 'react'

interface SdoxWatermarkProps extends ComponentProps<'a'> {
  contactPersonId?: string | number
  orgId?: string | number
  officeId?: string | number
  slug?: string
}

export const SdoxWatermark = (props: SdoxWatermarkProps) => {
  const {contactPersonId, orgId, officeId, slug, className, ...restProps} = props

  // this will strip the undefineds
  const payload = JSON.parse(JSON.stringify({cp: contactPersonId, org: orgId, office: officeId, slug}))
  const searchParams = new URLSearchParams(payload)
  const href = `https://www.sdox.io/?${searchParams.toString()}`

  return (
    <a
      href={href}
      target={'_blank'}
      style={{color: '#828282'}}
      className={twMerge('ml-1 font-bold underline', className)}
      rel={'noreferrer'}
      {...restProps}
    >
      <img
        src={'/static/frontend-js/logos/sdox-logo.svg'}
        alt={'sdox logo'}
        className={'h-full'}
      />
    </a>
  )
}
